import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = ["disabled"]
const _hoisted_3 = ["disabled"]
const _hoisted_4 = ["disabled"]
const _hoisted_5 = ["disabled"]

import ConfirmJobModal from "@/views/booking-details/ConfirmJobModal.vue";
import WaitingTimeModal from "@/views/booking-details/WaitingTimeModal.vue";
import { useConfirmDialog } from "@vueuse/core";
import { watch, computed } from "vue";
import type { Booking } from "@/models/your-bookings";
import { useUpdateJobStatus } from "@/store/booking";
import { toastError } from "@/store/toasts";


export default /*#__PURE__*/_defineComponent({
  __name: 'DriverActionBtns',
  props: {
    booking: null
  },
  emits: ["update:status"],
  setup(__props: any, { emit }: { emit: ({
  (e: "update:status", v: Booking): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  booking: Booking;
};





const showDriverError = (msg: string) => {
  toastError(msg, {
    id: "driver_action",
  });
};

const {
  isRevealed: wtimeModalVisible,
  reveal: showWtimeModal,
  cancel: hideWtimeModal,
} = useConfirmDialog();
const {
  isRevealed: confirmModalVisible,
  reveal: showConfirmModal,
  cancel: hideConfirmModal,
} = useConfirmDialog();

watch(
  () => props.booking.driverVehicle,
  (value) => {
    if (
      !value?.isJobStarted &&
      value?.canJobStarted &&
      props.booking.isJobStarted
    ) {
      showDriverError("Please start your job!");
    }
  }
);

const { updateJobStatus, isPending } = useUpdateJobStatus(props.booking.id);

const isWaitingChargeEnabled = computed(
  () =>
    !props.booking.isPastJob && !props.booking.customer.disableChargeWaitingTime
);

const onJobStatusUpdate = async (status: string) => {
  emit("update:status", await updateJobStatus(status));
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!__props.booking.hasDriverConfirmedJob)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "btn btn-block btn-confirm-job",
          onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_unref(showConfirmModal) && _unref(showConfirmModal)(...args)), ["prevent"]))
        }, " Confirm Job "))
      : _createCommentVNode("", true),
    (_unref(isWaitingChargeEnabled))
      ? (_openBlock(), _createElementBlock("button", {
          key: 1,
          class: "btn btn-block btn-secondary",
          onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_unref(showWtimeModal) && _unref(showWtimeModal)(...args)), ["prevent"]))
        }, " Waiting Time "))
      : _createCommentVNode("", true),
    (__props.booking.driverVehicle?.canJobStarted)
      ? (_openBlock(), _createElementBlock("button", {
          key: 2,
          disabled: _unref(isPending),
          class: "btn btn-block btn-secondary",
          onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (onJobStatusUpdate('JOB_STARTED')), ["prevent"]))
        }, " On the way ", 8, _hoisted_1))
      : (__props.booking.driverVehicle?.canArrivedAtPickup)
        ? (_openBlock(), _createElementBlock("button", {
            key: 3,
            disabled: _unref(isPending),
            class: "btn btn-block btn-secondary",
            onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (onJobStatusUpdate('ARRIVED_AT_PICKUP')), ["prevent"]))
          }, " Arrived at pickup ", 8, _hoisted_2))
        : (__props.booking.driverVehicle?.canPassengerOnBoard)
          ? (_openBlock(), _createElementBlock("button", {
              key: 4,
              disabled: _unref(isPending),
              class: "btn btn-block btn-secondary",
              onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (onJobStatusUpdate('PASSENGER_ON_BOARD')), ["prevent"]))
            }, " Passenger on board ", 8, _hoisted_3))
          : (__props.booking.driverVehicle?.canPassengerDropped)
            ? (_openBlock(), _createElementBlock("button", {
                key: 5,
                disabled: _unref(isPending),
                class: "btn btn-block btn-secondary",
                onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (onJobStatusUpdate('PASSENGER_DROPPED')), ["prevent"]))
              }, " Passenger dropped ", 8, _hoisted_4))
            : (__props.booking.driverVehicle?.canJobComplete)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 6,
                  disabled: _unref(isPending),
                  class: "btn btn-block btn-secondary",
                  onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (onJobStatusUpdate('JOB_COMPLETE')), ["prevent"]))
                }, " Job complete ", 8, _hoisted_5))
              : _createCommentVNode("", true),
    _createVNode(ConfirmJobModal, {
      show: _unref(confirmModalVisible),
      "booking-id": __props.booking.id,
      onClose: _unref(hideConfirmModal),
      onConfirmed: _cache[7] || (_cache[7] = ($event: any) => (emit('update:status', $event)))
    }, null, 8, ["show", "booking-id", "onClose"]),
    (_unref(isWaitingChargeEnabled))
      ? (_openBlock(), _createBlock(WaitingTimeModal, {
          key: 7,
          show: _unref(wtimeModalVisible),
          "booking-id": __props.booking.id,
          onClose: _unref(hideWtimeModal)
        }, null, 8, ["show", "booking-id", "onClose"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})